import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const CiCdIcon = () => (
  <SvgIcon width="32" height="32" viewBox="0 0 32 32">
    {/* Pipeline/workflow representation with connected blocks */}
    <rect x="5" y="12" width="6" height="8" rx="1" fill="#17E88F" />
    <rect x="13" y="12" width="6" height="8" rx="1" fill="#0FB870" />
    <rect x="21" y="12" width="6" height="8" rx="1" fill="#0D9359" />
    
    {/* Arrows connecting the blocks */}
    <path d="M11 16H13M19 16H21" stroke="#17E88F" strokeWidth="2" />
    
    {/* Cycle/refresh indicator */}
    <path
      d="M27 10C27 10 25 6 22 6C19 6 18 8 18 8"
      stroke="#17E88F"
      strokeWidth="1.5"
      fill="none"
      strokeLinecap="round"
    />
    <path d="M26 7L27 10L24 11" fill="#17E88F" />
  </SvgIcon>
);

export default CiCdIcon;
